// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1Awxi","large":"Header_large__1Qp1C","medium":"Header_medium__1r7CO","small":"Header_small__2mQiv","clickable":"Header_clickable__2Fdcd"};